import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { Form, InputGroup } from "react-bootstrap";
import RequiredLabel from "../../CustomCommons/RequiredLabel";
import { BASE_URL } from "../../Const/Url";
import { showToast } from "../../../utils/ToastHelper";
import { logout_func2 } from "../../Const/logoutCommon";
import { confirmAndRemoveMedia } from "../HeroBanner/mediaRemovalHelper";

const CreateCustomofferBanner = () => {
  const history = useHistory();

  const [header, setHeader] = useState("");
  const [subHeader, setSubHeader] = useState("");
  const [buttonText, setButtonText] = useState("");
  const [mediaType, setMediaType] = useState(0); // 0 = image, 1 = video
  const [isActive, setIsActive] = useState(true);
  const [startAt, setStartAt] = useState("");
  const [endAt, setEndAt] = useState("");

  const [bannerId, setBannerId] = useState(null);
  const [bannerName, setBannerName] = useState("");
  const [bannerPreview, setBannerPreview] = useState("");

  const [mobileBannerId, setMobileBannerId] = useState(null);
  const [mobileBannerName, setMobileBannerName] = useState("");
  const [mobileBannerPreview, setMobileBannerPreview] = useState("");

  const [videoId, setVideoId] = useState(null);
  const [videoName, setVideoName] = useState("");
  const [videoPreview, setVideoPreview] = useState("");

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [, setOnlogoutHide] = useState(0);

  const uploadDocument = (file, onSuccess, docType = 0) => {
    if (!file) return;
    const formData = new FormData();
    formData.append("document", file);
    formData.append("doc_type", docType);

    axios
      .post(`${BASE_URL}api/v1/auth/documents/upload/`, formData)
      .then((res) => {
        if (res?.data?.status) {
          onSuccess(res?.data?.data?.id);
          showToast("success", "File uploaded successfully");
        } else {
          showToast("error", "Failed to upload file");
        }
      })
      .catch((err) => {
        const message =
          err?.response?.data?.errors?.document?.[0] ||
          err?.response?.data?.message ||
          "Upload failed";
        showToast("error", message);
      });
  };

  const handleBannerUpload = (event) => {
    const file = event.target.files?.[0];
    if (!file) return;
    uploadDocument(file, (id) => {
      setBannerId(id);
      setBannerName(file.name);
      const reader = new FileReader();
      reader.onload = () => setBannerPreview(reader.result);
      reader.readAsDataURL(file);
    });
  };

  const handleMobileBannerUpload = (event) => {
    const file = event.target.files?.[0];
    if (!file) return;
    uploadDocument(file, (id) => {
      setMobileBannerId(id);
      setMobileBannerName(file.name);
      const reader = new FileReader();
      reader.onload = () => setMobileBannerPreview(reader.result);
      reader.readAsDataURL(file);
    });
  };

  const handleVideoUpload = (event) => {
    const file = event.target.files?.[0];
    if (!file) return;
    uploadDocument(
      file,
      (id) => {
        setVideoId(id);
        setVideoName(file.name);
      },
      1
    );
    const reader = new FileReader();
    reader.onload = () => setVideoPreview(reader.result);
    reader.readAsDataURL(file);
  };

  const resetMedia = () => {
    setBannerId(null);
    setBannerName("");
    setBannerPreview("");
    setMobileBannerId(null);
    setMobileBannerName("");
    setMobileBannerPreview("");
    setVideoId(null);
    setVideoName("");
    setVideoPreview("");
  };

  const handleRemoveMedia = (type) => {
    confirmAndRemoveMedia({
      onConfirm: () => {
        if (type === "banner") {
          setBannerId(null);
          setBannerName("");
          setBannerPreview("");
        } else if (type === "mobileBanner") {
          setMobileBannerId(null);
          setMobileBannerName("");
          setMobileBannerPreview("");
        } else if (type === "video") {
          setVideoId(null);
          setVideoName("");
          setVideoPreview("");
        }
      },
    });
  };

  const validateForm = () => {
    if (!header.trim()) {
      showToast("error", "Header is required.");
      return false;
    }
    if (!subHeader.trim()) {
      showToast("error", "Sub header is required.");
      return false;
    }
    if (!buttonText.trim()) {
      showToast("error", "Button text is required.");
      return false;
    }
    if (Number(mediaType) === 0) {
      if (!bannerId) {
        showToast("error", "Please upload a banner image.");
        return false;
      }
      if (!mobileBannerId) {
        showToast("error", "Please upload a mobile banner image.");
        return false;
      }
    }
    if (Number(mediaType) === 1) {
      if (!videoId) {
        showToast("error", "Please upload a banner video.");
        return false;
      }
    }
    return true;
  };

  const handleSubmit = () => {
    if (!validateForm()) return;

    const payload = {
      header: header.trim(),
      sub_header: subHeader.trim(),
      button_text: buttonText.trim(),
      is_active: isActive,
      media_type: Number(mediaType),
      banner: Number(mediaType) === 0 ? bannerId : null,
      mobile_banner: Number(mediaType) === 0 ? mobileBannerId : null,
      video: Number(mediaType) === 1 ? videoId : null,
      start_at: startAt ? new Date(startAt).toISOString() : null,
      end_at: endAt ? new Date(endAt).toISOString() : null,
    };

    setIsSubmitting(true);
    axios
      .post(
        `${BASE_URL}api/v1/frontend/admin/v2/custom-offer-banners/`,
        payload
      )
      .then(() => {
        showToast("success", "Custom offer banner created successfully.");
        history.push("/website-settings/custom-offer-banner-list");
      })
      .catch((err) => {
        const status = err?.response?.status;
        if (status === 401) {
          logout_func2(setOnlogoutHide, history);
          return;
        }
        const message =
          err?.response?.data?.errors?.non_field_errors?.[0] ||
          err?.response?.data?.message ||
          "Failed to create custom offer banner. Please try again.";
        showToast("error", message);
      })
      .finally(() => setIsSubmitting(false));
  };

  const handleCancel = () => {
    history.push("/website-settings/custom-offer-banner-list");
  };

  return (
    <div className="categorey-parent new-categorey-parent an">
      <div className="bg-white add-div">
        <div
          className="d-flex align-items-center justify-content-between"
          style={{ padding: "20px 35px", border: "0.5px solid #E0E0E0" }}
        >
          <h3 style={{ fontSize: "23px", marginTop: "6px" }}>
            Create Custom Offer Banner
          </h3>
        </div>

        <div
          style={{
            padding: "20px 35px",
            borderBottom: "0.5px solid #E0E0E0",
            borderRight: "0.5px solid #E0E0E0",
            borderLeft: "0.5px solid #E0E0E0",
          }}
          className="row"
        >
          <div className="col-12 col-md-6">
            <RequiredLabel text="Header" />
            <InputGroup className="mb-3" style={{ height: "47px" }}>
              <Form.Control
                aria-label="Header"
                style={{ backgroundColor: "#FAFAFA" }}
                value={header}
                onChange={(e) => setHeader(e.target.value)}
              />
            </InputGroup>
          </div>

          <div className="col-12 col-md-6">
            <RequiredLabel text="Media Type" />
            <InputGroup className="mb-3" style={{ height: "47px" }}>
              <Form.Select
                aria-label="Media Type"
                style={{ backgroundColor: "#FAFAFA" }}
                value={mediaType}
                onChange={(e) => {
                  const value = Number(e.target.value);
                  setMediaType(value);
                  if (value === 0) {
                    setVideoId(null);
                    setVideoName("");
                    setVideoPreview("");
                  } else {
                    setBannerId(null);
                    setBannerName("");
                    setBannerPreview("");
                    setMobileBannerId(null);
                    setMobileBannerName("");
                    setMobileBannerPreview("");
                  }
                }}
              >
                <option value={0}>Image</option>
                <option value={1}>Video</option>
              </Form.Select>
            </InputGroup>
          </div>

          <div className="col-12 col-md-6">
            <RequiredLabel text="Sub Header" />
            <InputGroup className="mb-3" style={{ height: "47px" }}>
              <Form.Control
                aria-label="Sub Header"
                style={{ backgroundColor: "#FAFAFA" }}
                value={subHeader}
                onChange={(e) => setSubHeader(e.target.value)}
              />
            </InputGroup>
          </div>

          <div className="col-12 col-md-6">
            <RequiredLabel text="Button Text" />
            <InputGroup className="mb-3" style={{ height: "47px" }}>
              <Form.Control
                aria-label="Button Text"
                style={{ backgroundColor: "#FAFAFA" }}
                value={buttonText}
                onChange={(e) => setButtonText(e.target.value)}
              />
            </InputGroup>
          </div>

          <div className="col-12 col-md-6">
            {/* <RequiredLabel text="Start At" /> */}
            <p>Start At</p>
            <InputGroup className="mb-3">
              <Form.Control
                type="datetime-local"
                style={{ backgroundColor: "#FAFAFA" }}
                value={startAt}
                onChange={(e) => setStartAt(e.target.value)}
              />
            </InputGroup>
          </div>

          <div className="col-12 col-md-6">
            {/* <RequiredLabel text="End At" /> */}
            <p>End At</p>
            <InputGroup className="mb-3">
              <Form.Control
                type="datetime-local"
                style={{ backgroundColor: "#FAFAFA" }}
                value={endAt}
                onChange={(e) => setEndAt(e.target.value)}
              />
            </InputGroup>
          </div>

          {Number(mediaType) === 0 && (
            <>
              <div className="col-12">
                <RequiredLabel text="Banner Image (Desktop)" />
                <p style={{ marginTop: "10px", color: "red" }}>
                  NB: Upload image in (height-420px, width-1920px) for Banner.
                </p>
                <div
                  className="w-100 browse-main d-flex align-items-center"
                  style={{
                    height: "55px",
                    border: "1px solid #E0E0E0",
                    borderRadius: "7px",
                    overflowX: "hidden",
                  }}
                >
                  <p className="my-2 ms-2" style={{ color: "#4F4F4F" }}>
                    {bannerName ? "File Chosen" : "No File Chosen"}
                  </p>
                  <div className="file-up">
                    <input
                      type="file"
                      accept="image/*"
                      onChange={handleBannerUpload}
                    />
                    <p>Browse</p>
                  </div>
                </div>
                {bannerPreview && (
                  <div className="my-2">
                    <img
                      height={90}
                      width={90}
                      src={bannerPreview}
                      alt="banner"
                    />
                    <br />
                    <button
                      onClick={() => handleRemoveMedia("banner")}
                      className="remove-btn btn btn-small mt-1 rounded"
                      style={{ border: "1px solid gray !important" }}
                    >
                      Remove
                    </button>
                  </div>
                )}
              </div>

              <div className="col-12 mt-3">
                <RequiredLabel text="Banner Image (Mobile)" />
                <p style={{ marginTop: "10px", color: "red" }}>
                  NB: Upload image in (height-250px, width-360px) for Banner.
                </p>
                <div
                  className="w-100 browse-main d-flex align-items-center"
                  style={{
                    height: "55px",
                    border: "1px solid #E0E0E0",
                    borderRadius: "7px",
                    overflowX: "hidden",
                  }}
                >
                  <p className="my-2 ms-2" style={{ color: "#4F4F4F" }}>
                    {mobileBannerName ? "File Chosen" : "No File Chosen"}
                  </p>
                  <div className="file-up">
                    <input
                      type="file"
                      accept="image/*"
                      onChange={handleMobileBannerUpload}
                    />
                    <p>Browse</p>
                  </div>
                </div>
                {mobileBannerPreview && (
                  <div className="my-2">
                    <img
                      height={90}
                      width={90}
                      src={mobileBannerPreview}
                      alt="mobile banner"
                    />
                    <br />
                    <button
                      onClick={() => handleRemoveMedia("mobileBanner")}
                      className="remove-btn btn btn-small mt-1 rounded"
                      style={{ border: "1px solid gray !important" }}
                    >
                      Remove
                    </button>
                  </div>
                )}
              </div>
            </>
          )}

          {Number(mediaType) === 1 && (
            <div className="col-12">
              <RequiredLabel text="Banner Video" />
              <div
                className="w-100 browse-main d-flex align-items-center"
                style={{
                  height: "55px",
                  border: "1px solid #E0E0E0",
                  borderRadius: "7px",
                  overflowX: "hidden",
                }}
              >
                <p className="my-2 ms-2" style={{ color: "#4F4F4F" }}>
                  {videoName ? "File Chosen" : "No File Chosen"}
                </p>
                <div className="file-up">
                  <input
                    type="file"
                    accept="video/*"
                    onChange={handleVideoUpload}
                  />
                  <p>Browse</p>
                </div>
              </div>
              {videoPreview && (
                <div className="my-2">
                  <video height={120} width={160} src={videoPreview} controls />
                  <br />
                  <button
                    onClick={() => handleRemoveMedia("video")}
                    className="remove-btn btn btn-small mt-1 rounded"
                    style={{ border: "1px solid gray !important" }}
                  >
                    Remove
                  </button>
                </div>
              )}
            </div>
          )}

          <div className="col-12 mt-4">
            <h5>Status</h5>
            <p style={{ color: "#8E8E93" }}>( Toggle visibility )</p>
            <div
              className="d-flex justify-content-between align-items-center py-3 px-3"
              style={{ backgroundColor: "#F2F2F7", borderRadius: "8px" }}
            >
              <span>{isActive ? "Active" : "Inactive"}</span>
              <div className="form-check form-switch">
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={isActive}
                  onChange={(e) => setIsActive(e.target.checked)}
                />
              </div>
            </div>
          </div>

          <div className="mt-4">
            <button
              onClick={handleSubmit}
              className="save-btn me-2 mt-2"
              style={{ background: "#000", color: "white" }}
              disabled={isSubmitting}
            >
              {isSubmitting ? "Saving..." : "Save"}
            </button>
            <button
              onClick={() => {
                resetMedia();
                handleCancel();
              }}
              className="save-btn mt-2"
              style={{ border: ".4px solid #E0E0E0 !important" }}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateCustomofferBanner;
